<template>
  <general-layout>
    <router-view></router-view>
  </general-layout>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
</style>